<template>
  <b-table
    :data="scaleProducts"
    narrowed
    hoverable
    @click="editScaleProduct"
    id="scale-products-table"
    style="cursor: pointer"
  >
    <b-table-column
      field="code"
      :label="$t('scaleProducts.code')"
      sortable
      v-slot="props"
    >
      {{ props.row.code }}
    </b-table-column>

    <b-table-column
      field="n"
      :label="$t('common.name')"
      sortable
      v-slot="props"
    >
      {{ props.row.n }}
    </b-table-column>

    <b-table-column
      field="saleType"
      :label="$t('scaleProducts.saleType')"
      sortable
      v-slot="props"
    >
      {{
        props.row.saleType === "weight"
          ? $t("scaleProducts.saleTypeWeight")
          : props.row.saleType === "unit"
          ? $t("scaleProducts.saleTypeUnit")
          : "-"
      }}
    </b-table-column>

    <b-table-column
      field="option"
      :label="$t('scaleProducts.option')"
      sortable
      v-slot="props"
    >
      {{
        props.row.option === "totalPrice"
          ? $t("scaleProducts.totalPrice")
          : props.row.option === "weightQty"
          ? $t("scaleProducts.weightQty")
          : "-"
      }}
    </b-table-column>

    <b-table-column
      field="lc"
      :label="$t('scaleProducts.cost')"
      sortable
      v-slot="props"
    >
      {{ `${payments.currencySymbol}${formatMoney(props.row.lc)}` }}
    </b-table-column>

    <b-table-column
      field="unit"
      :label="$t('scaleProducts.unit')"
      sortable
      v-slot="props"
    >
      {{ props.row.unit }}
    </b-table-column>

    <b-table-column
      field="c"
      :label="$t('scaleProducts.category')"
      sortable
      v-slot="props"
    >
      {{ getCategoryName(props.row.c) }}
    </b-table-column>

    <b-table-column
      field="s"
      :label="$t('scaleProducts.subcategory')"
      sortable
      v-slot="props"
    >
      {{ getSubcategoryName(props.row.c, props.row.s) }}
    </b-table-column>

    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="sad-cry" size="is-large"></b-icon>
          </p>
          <p>{{ $t("common.tableEmptyMessage") }}</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "../../mixins/mask";

export default {
  props: ["scaleProducts"],

  mixins: [mask],

  methods: {
    editScaleProduct(scaleProduct) {
      this.$emit("edit-scale-product", scaleProduct);
    },

    getCategoryName(category) {
      return this.categories.filter(c => {
        return c._id.toString() === category.toString();
      })[0].name;
    },

    getSubcategoryName(category, subcategory) {
      const index = this.categories.findIndex(c => {
        return c._id.toString() === category.toString();
      });
      return this.categories[index].subcategories.filter(s => {
        return s._id.toString() === subcategory.toString();
      })[0].name;
    }
  },

  computed: {
    ...mapGetters(["categories", "payments"])
  }
};
</script>

<style scoped>
#scale-products-table {
  cursor: pointer !important;
}
</style>
